import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import ArrowRight from '../Icons/ArrowRight.js';
import Panel from '../Panel.js';
import { PaymentPlanProgress, PaymentPlanStatusBadge, } from '../PaymentPlan/PaymentPlanIndicators.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import HistItem from './HistItem.js';
const PaymentPlanItem = ({ date, data }) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(HistItem, { date: date, heading: React.createElement("div", null,
            data.createdBy && (React.createElement("span", { style: { marginRight: '0.5em' } },
                React.createElement(PerformedBy, { performedBy: data.createdBy }))),
            lang.history.paymentPlanCreated) },
        React.createElement(Panel, null,
            React.createElement(PlanSummary, null,
                React.createElement(PaymentPlanContent, null, data.plan.length > 0 && (React.createElement(PlanDates, null,
                    moment(data.plan[0].date).format(THEME.DATE_FORMAT_SHORT),
                    React.createElement(ArrowRight, { size: "1em", "aria-hidden": "true" }),
                    moment(data.plan[data.plan.length - 1].date).format(THEME.DATE_FORMAT_SHORT)))),
                React.createElement(Indicators, null,
                    React.createElement(PaymentPlanProgress, { entries: data.plan }),
                    React.createElement(PaymentPlanStatusBadge, { status: data.status }))))));
};
export default PaymentPlanItem;
const PaymentPlanContent = styled.div ``;
const PlanSummary = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
const PlanDates = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const Indicators = styled.div `
  display: flex;
  gap: 8px;
`;
//# sourceMappingURL=PaymentPlanItem.js.map